import type { FC } from 'react';
import { lazy } from 'react';
import type { AggregateEuRootRequest } from 'src/apis/aggregate-eu/use-aggregate-eu-root';
import type { Successful } from 'src/hooks/use-axios';

const Page = lazy(() => import('./page'));

type Props = {
  aggregateEuRootRequest: Successful<AggregateEuRootRequest>;
};

export const AggregateEuTenderingAndMatching: FC<Props> = ({
  aggregateEuRootRequest,
}) => {
  return <Page aggregateEuRootRequest={aggregateEuRootRequest} />;
};
